// src/data/productsData.js

import image1 from '../assets/shoes/shoe1.png';
import image2 from '../assets/shoes/shoe2.png';
import image3 from '../assets/shoes/shoe3.png';
import image4 from '../assets/shoes/shoe4.png';
import image5 from '../assets/shoes/shoe5.png';
import image6 from '../assets/shoes/shoe6.png';
import image7 from '../assets/shoes/shoe7.png';
import image8 from '../assets/shoes/shoe8.png';
import image9 from '../assets/shoes/shoe9.png';
import image10 from '../assets/shoes/shoe10.png';
import image11 from '../assets/shoes/shoe11.png';
import image12 from '../assets/shoes/shoe12.png';
import image13 from '../assets/shoes/shoe13.png';
import image14 from '../assets/shoes/shoe14.png';
import image15 from '../assets/shoes/shoe15.png';
import image16 from '../assets/shoes/shoe16.png';

const productsData = [
  { id: 1, brand: 'Nike', name: 'Air Max', price: 'N63,999', color: '#8A2BE2', image: image1, type: 'Popular', gender: 'Both' },
  { id: 2, brand: 'Nike', name: 'Air Max', price: 'N63,999', color: '#A9A9A9', image: image2, type: 'Popular', gender: 'Both' },
  { id: 3, brand: 'Nike', name: 'Air Max', price: 'N63,999', color: '#FFD700', image: image3, type: 'Popular', gender: 'Both' },
  { id: 4, brand: 'Nike', name: 'Air Max', price: 'N63,999', color: '#DA70D6', image: image4, type: 'Popular', gender: 'Both' },
  { id: 5, brand: 'Nike', name: 'Air Max', price: 'N63,999', color: '#DA70D6', image: image5, type: 'Popular', gender: 'Both' },
  { id: 6, brand: 'Nike', name: 'Air Max', price: 'N63,999', color: '#DA70D6', image: image6, type: 'Popular', gender: 'Both' },
  { id: 7, brand: 'Nike', name: 'Air Max', price: 'N63,999', color: '#DA70D6', image: image7, type: 'Popular', gender: 'Both' },
  { id: 8, brand: 'Nike', name: 'Air Max', price: 'N63,999', color: '#DA70D6', image: image8, type: 'Popular', gender: 'Both' },
  { id: 9, brand: 'Nike', name: 'Air Max', price: 'N63,999', color: '#DA70D6', image: image9, type: 'Popular', gender: 'Both' },
  { id: 10, brand: 'Nike', name: 'Air Max', price: 'N63,999', color: '#DA70D6', image: image10, type: 'Popular', gender: 'Both' },
  { id: 11, brand: 'Nike', name: 'Air Max', price: 'N63,999', color: '#DA70D6', image: image11, type: 'Popular', gender: 'Both' },
  { id: 12, brand: 'Nike', name: 'Air Max', price: 'N63,999', color: '#DA70D6', image: image12, type: 'Popular', gender: 'Both' },
  { id: 13, brand: 'Nike', name: 'Air Max', price: 'N63,999', color: '#FF69B4', image: image13, type: 'New Releases', gender: 'Both' },
  { id: 14, brand: 'Adidas', name: 'Ultra Boost', price: 'N70,000', color: '#FF6347', image: image14, gender: 'Male' },
  { id: 15, brand: 'Adidas', name: 'Ultra Boost', price: 'N70,000', color: '#4682B4', image: image15, gender: 'Female' },
  { id: 16, brand: 'Adidas', name: 'Ultra Boost', price: 'N70,000', color: '#9ACD32', image: image16, gender: 'Both' },
  // Add more products as needed
];

export default productsData;
